/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { aiAgentV2ControllerCancelRequest } from "./aiAgentV2ControllerCancelRequest";
import { aiAgentV2ControllerGetConversationHistory } from "./aiAgentV2ControllerGetConversationHistory";
import { aiAgentV2ControllerGetInternalConversationHistory } from "./aiAgentV2ControllerGetInternalConversationHistory";
import { aiAgentV2ControllerSaveAddendumToProject } from "./aiAgentV2ControllerSaveAddendumToProject";
import { aiAgentV2ControllerSaveAsVersion } from "./aiAgentV2ControllerSaveAsVersion";
import { aiAgentV2ControllerStreamResponse } from "./aiAgentV2ControllerStreamResponse";
import { aiAgentV2ControllerSubmitExplain } from "./aiAgentV2ControllerSubmitExplain";
import { aiAgentV2ControllerSubmitQuery } from "./aiAgentV2ControllerSubmitQuery";
import { aiAgentV2ControllerUpdateSavedVersion } from "./aiAgentV2ControllerUpdateSavedVersion";
import { deepAnalysisControllerAnswer } from "./deepAnalysisControllerAnswer";
import { deepAnalysisControllerCancel } from "./deepAnalysisControllerCancel";
import { deepAnalysisControllerExecute } from "./deepAnalysisControllerExecute";
import { deepAnalysisControllerStart } from "./deepAnalysisControllerStart";
import { deepAnalysisControllerStream } from "./deepAnalysisControllerStream";

export function aiAgentV2Service() {
  return { aiAgentV2ControllerSubmitQuery, aiAgentV2ControllerStreamResponse, aiAgentV2ControllerGetConversationHistory, aiAgentV2ControllerCancelRequest, aiAgentV2ControllerSubmitExplain, aiAgentV2ControllerGetInternalConversationHistory, aiAgentV2ControllerSaveAsVersion, aiAgentV2ControllerSaveAddendumToProject, aiAgentV2ControllerUpdateSavedVersion, deepAnalysisControllerStart, deepAnalysisControllerAnswer, deepAnalysisControllerExecute, deepAnalysisControllerStream, deepAnalysisControllerCancel }
}